import * as React from "react";
const SvgFiBrandsJoomla = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-joomla_svg__a)">
      <path d="m9.202 16.983 2.367-2.369L6.23 9.28a1.974 1.974 0 0 1 .004-2.788 1.97 1.97 0 0 1 2.785 0l.184.183 2.37-2.368-.184-.184a5.32 5.32 0 0 0-4.98-1.416 3.21 3.21 0 1 0-3.878 3.652 5.32 5.32 0 0 0 1.332 5.29z" />
      <path d="M12.314 4.127a5.32 5.32 0 0 1 5.264-1.344 3.21 3.21 0 1 1 3.604 3.626 5.32 5.32 0 0 1-1.35 5.235l-.185.185-2.367-2.37.183-.184a1.967 1.967 0 1 0-2.781-2.78L9.344 11.83l-2.37-2.368z" />
      <path d="M17.463 14.943a1.966 1.966 0 1 1-2.781 2.781l-.182-.182-2.367 2.37.182.181a5.32 5.32 0 0 0 5.328 1.322 3.21 3.21 0 1 0 3.599-3.819 5.32 5.32 0 0 0-1.41-5.02L14.5 7.237l-2.37 2.367z" />
      <path d="m14.352 12.39 2.367 2.37-5.331 5.336a5.32 5.32 0 0 1-5.047 1.4 3.21 3.21 0 0 1-3.13 2.49 3.21 3.21 0 0 1-.741-6.336 5.32 5.32 0 0 1 1.393-5.079l.181-.18 2.37 2.367-.184.182a1.972 1.972 0 0 0 2.789 2.787z" />
    </g>
    <defs>
      <clipPath id="fi-brands-joomla_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsJoomla;
